import { RAW_DATA_ENDPOINT } from "./endpoints";
import { fetcher } from "./utils";

export const getRawData = async (testId?: string | number) => {
    if (!testId) return null;

    const data = await fetcher(RAW_DATA_ENDPOINT, {
        method: "GET",
        params: {
            test_id: testId,
        }
    });

    return data;
}